var checkedProducts = [];
const addBtn = document.getElementById('addToCart');
const noThanks = document.getElementById('noThanks');
const stickyAddBtn = document.getElementById('stickybtn');

noThanks.addEventListener('click', function() {
  addProducts(checkedProducts);
});

stickyAddBtn?.addEventListener('click', function() {
  addProducts(checkedProducts);
});

addBtn.addEventListener('click', function() {
  document.querySelectorAll("mm-product-form .input-check:checked").forEach((checkedVariant)=> {
    variantId = checkedVariant.value;
    checkedProducts.push({
      id: variantId,
      quantity: 1
    });      
    
  })
  addProducts(checkedProducts);
});

function addProducts(data){
  const mainVariantId = document.querySelector('[data-add-to-cart].popUpBtn').getAttribute('main-variant');
  console.log(mainVariantId, "MAIN VARIANT");
  var quantity_value = document.querySelector('[name="quantity"]').value;

  checkedProducts.push({
    id: mainVariantId,
    quantity: quantity_value
  }); 
  
  let formData = {
    items: data,
  };
  
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      const closePopup = document.getElementById('closePopup');
      closePopup.click();
      
      let ca = new theme.Drawers('CartDrawer','cart');
      document.dispatchEvent(new CustomEvent('cart:build'));
      ca.open(); 

      checkedProducts = [];
    })
    .catch((error) => {
      console.error("Error:", error);
    });    
}